import React, { useEffect, useState } from "react";

export const History = ({ ticketId, authToken }) => {
  const [history, setHistory] = useState([]);

  useEffect(() => {
    if (!ticketId || !authToken) return;

    fetch(
      `${process.env.REACT_APP_BACKEND_URL}/API/V2/Tickets/${ticketId}/history`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      },
    )
      .then((response) => {
        if (response.status === 401) {
          window.location.href = process.env.REACT_APP_JBM_LOGIN_URL;
          return null;
        }
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.json();
      })
      .then((responseData) => {
        if (!responseData) return;
        if (Array.isArray(responseData)) {
          setHistory(responseData);
        }
      })
      .catch((err) => {
        console.error("History fetch error:", err);
      });
  }, [ticketId, authToken]);
  if (history.length === 0) {
    return (
      <div className="h-full flex flex-col">
        <div className="rounded-2xl shadow-sm border border-gray-100 flex flex-col items-center justify-center bg-white flex-1 min-h-0 text-xs">
          <div>
            <svg
              width="48"
              height="31"
              viewBox="0 0 64 41"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g transform="translate(0 1)" fill="none" fillRule="evenodd">
                <ellipse fill="#f5f5f5" cx="32" cy="33" rx="32" ry="7" />
                <g fillRule="nonzero" stroke="#d9d9d9">
                  <path d="M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z" />
                  <path
                    d="M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z"
                    fill="#fafafa"
                  />
                </g>
              </g>
            </svg>
          </div>
          <div className="font-jio-var font-semibold text-gray80 mt-2">
            No History Available.
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="h-full flex flex-col">
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4 pr-0 flex-1 flex flex-col min-h-0 text-xs">
        <div className="flex-1 min-h-0 overflow-y-auto thin-scrollbar mr-2">
          <table className="min-w-full border-collapse">
            <thead className="sticky top-0 z-10">
              <tr>
                <th className="border border-gray-300 p-1.5 bg-gray-100">
                  Changed By
                </th>
                <th className="border border-gray-300 p-1.5 bg-gray-100">
                  Timestamp
                </th>
                <th className="border border-gray-300 p-1.5 bg-gray-100">
                  Changes
                </th>
              </tr>
            </thead>
            <tbody>
              {history.map((entry, index) => (
                <tr key={index}>
                  <td className="border border-gray-300 p-1.5">
                    {entry.changedBy}
                  </td>
                  <td className="border border-gray-300 p-1.5 whitespace-nowrap">
                    {new Date(entry.timestamp).toLocaleString("en-IN", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    })}
                  </td>
                  <td className="border border-gray-300 p-1.5">
                    <ul className="list-none m-0 p-0">
                      {entry.changes.map((change, idx) => (
                        <li key={idx}>
                          <strong>{change.field}:</strong>{" "}
                          {typeof change.oldValue === "object"
                            ? JSON.stringify(change.oldValue)
                            : String(change.oldValue)}{" "}
                          →{" "}
                          {typeof change.newValue === "object"
                            ? JSON.stringify(change.newValue)
                            : String(change.newValue)}
                        </li>
                      ))}
                    </ul>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
